
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    init,
    loadTranferPayment,
} from '../../modules/payment/payment'

import styled, { css } from 'styled-components';
import AdminClubCoupon from '../../components/admin/AdminClubCoupon';
import client, { url } from '../../lib/api/client';
import qs from 'qs';
import { loadAllClubList } from '../../modules/clubs/clubs';
import ClubSelectItem from '../../components/admin/ClubSelectItem';
import AdminClubRunningTrack from '../../components/admin/AdminClubRunningTrack';
import AdminClubDoorInfo from '../../components/admin/AdminClubDoorInfo';
import AdminClubStatusInfo from '../../components/admin/AdminClubStatusInfo';
import AdminClubRunningTrackInfo from '../../components/admin/AdminClubRunningTrackInfo';
import AdminClubYoutubeMusic from '../../components/admin/AdminClubYoutubeMusic';
import AdminLauncherAppDownload from '../../components/admin/AdminLauncherAppDownload';
import palette from '../../lib/styles/palette';
import { ZetaViewTabs } from '../../components/admin/zeta/ZetaUi';
import ZetaRanking from '../../components/admin/zeta/ZetaRanking';
import ZetaDailyStats from '../../components/admin/zeta/ZetaDailyStats';
import ZetaMembers from '../../components/admin/zeta/ZetaMembers';
import ZetaMultiRun from '../../components/admin/zeta/ZetaMultiRun';
import { presetRange, rangeUnix } from '../../components/admin/zeta/zetaUtil';

// 클럽 화면 안의 보기 — 기기·로그인(기존 대시보드·실시간) 다음에 모니터링 탭. 모두 기존 API만 쓴다.
const VIEW_TABS = [
    ['dash', '기기·로그인'],
    ['rank', '랭킹'],
    //--> 일별 기록 현황 · 기록한 회원은 Koa 서버 수정(날짜별 기록·전체 명단) 뒤에 다시 연다. 화면 코드는 그대로 둔다.
    // ['stats', '일별 기록 현황'],
    // ['members', '기록한 회원'],
    ['mr', '멀티런 기록'],
];

// 기간 안 날짜별 로그인 횟수 → 합계
const sumLoginLog = (rows) => rows.reduce((a, x) => ({
    faceLoginCount: a.faceLoginCount + (Number(x.faceLoginCount) || 0),
    faceLoginFailCount: a.faceLoginFailCount + (Number(x.faceLoginFailCount) || 0),
    numberLoginCount: a.numberLoginCount + (Number(x.numberLoginCount) || 0),
    notLoginCount: a.notLoginCount + (Number(x.notLoginCount) || 0),
}), { faceLoginCount: 0, faceLoginFailCount: 0, numberLoginCount: 0, notLoginCount: 0 });

const TabBlock = styled.div`
  display: flex;
  margin-bottom: 2rem;
`;

const TabText = styled.div`
  font-size: 16pt;
  cursor: pointer;
  & + & {
    margin-left: 50px;
  }
  ${(props) =>
    props.active &&
    css`
      font-weight: 700;
      color: ${palette.webCyan[5]};
    `}
`;

const AdminClubRunningTrackInfoContainer = ({history}) => {

    const dispatch = useDispatch();
    const {
      user,
      socketKey,
      clubs,
    } = useSelector(({ user, socket, payment, clubs }) => ({
        user: user.user,
        socketKey: socket.socketKey,
        clubs: clubs.clubs,
    }));

    const [subTab, setSubTab] = useState('club');
    const [viewTab, setViewTab] = useState('dash');
    const [dashRange, setDashRange] = useState(() => presetRange('today'));
    const [clubList, setClubList] = useState("")
    const [selectClub, setSelectClub] = useState(0)
    const [selectClubInfo, setSelectClubInfo] = useState(null)
    const [deviceInfos, setDeviceInfos] = useState([])
    // 경기현황·경기완주율(clubracelog·clubcompletelog)은 대시보드에서 뺐다(2026-10-11) — 대신 얼굴로그인 실패 기록.
    const [dashboardData, setDashboardData] = useState({
        loginLog: null,
        loginLogDays: null,
        faceFailLog: []
    })
    const [weekGraphData, setWeekGraphData] = useState({
        loginLog: null
    })

    useEffect(() => {
        let _clubList = [];
        if(clubs && clubs.length > 0) {
            for (let i = 0; i < clubs.length; i++) {
                _clubList.push({
                    label:clubs[i].name, value:clubs[i].clubID
                })

            }
        }
        setClubList(_clubList)
    }, [clubs])

    useEffect(() => {
        _resetClubInfo(selectClub)
    }, [selectClub])

    useEffect(() => {
        loadDashboardData(selectClub, dashRange);
    }, [selectClub, dashRange])

    const _resetClubInfo = async (clubid)=>{
        const _clubid = parseInt(clubid)
        console.log('111 : ', _clubid, clubs)
        if(_clubid == 0) {
            return;
        }
        console.log('2222 : ', _clubid, clubs)


        let res = await client.get(`${url}/api/runningtrack/deviceinfo/${_clubid}`)
        console.log('deviceinfo : ', res.data)
        if(res && res.data && res.data.result == 1) {
            setDeviceInfos(res.data.infos)
        }
        else {
            setDeviceInfos([])
        }

        for (let i = 0; i < clubs.length; i++) {
            if(clubs[i].clubID == _clubid) {
                console.log('_resetClubInfo : ', clubs[i])
                setSelectClubInfo({
                    isEdit:false,
                    ...clubs[i]
                })
                break;
            }
        }
    }

    // 대시보드 데이터 로드 — 기간(range)은 대시보드 머리의 기간 선택. 기본은 오늘.
    const loadDashboardData = async (clubid, range) => {
        if (!clubid || clubid === 0) return;

        const { startTime, endTime } = rangeUnix(range || presetRange('today'));

        try {
            const [loginRes, faceFailLog] = await Promise.all([
                client.get(`${url}/api/runningtrack/clubloginlog/${clubid}?startTime=${startTime}&endTime=${endTime}`),
                loadFaceFailList(clubid, startTime, endTime)
            ]);

            console.log('loginRes : ', loginRes.data)

            const days = loginRes.data.result === 1 && Array.isArray(loginRes.data.infos) ? loginRes.data.infos : null;
            setDashboardData({
                loginLog: days ? sumLoginLog(days) : null,
                loginLogDays: days,
                faceFailLog
            });
        } catch (error) {
            console.error('대시보드 데이터 로드 실패:', error);
        }
    };

    // 얼굴로그인 실패 기록(최신순) — 사진 주소는 서버가 만든 10분짜리 서명 주소라, 로그인한 관리자·클럽 소유자만 받는다.
    //   ★실패하면 null — 빈 배열([])은 «실패가 없었다»는 뜻이라, 권한 없음·서버 오류를 0건으로 보이게 하면 안 된다.
    const loadFaceFailList = async (clubid, startTime, endTime) => {
        try {
            const queryString = qs.stringify({ startTime, endTime, socketKey });
            const res = await client.get(`${url}/api/runningtrack/facefaillog/${clubid}?${queryString}`);
            if (res && res.data && res.data.result === 1) return res.data.infos || [];
            console.error('얼굴로그인 실패 기록 거부:', res && res.data);
            return null;
        } catch (error) {
            console.error('얼굴로그인 실패 기록 로드 실패:', error);
            return null;
        }
    };

    // 주간 그래프 데이터 로드 — 얼굴로그인 성공율 막대도 카드와 같은 방문 기준으로 그리려고 그 주 실패 기록을 같이 받는다.
    const loadWeekGraphData = async (clubid, startTime, endTime) => {
        if (!clubid || clubid === 0) return;

        try {
            const [loginRes, faceFailLog] = await Promise.all([
                client.get(`${url}/api/runningtrack/clubloginlog/${clubid}?startTime=${startTime}&endTime=${endTime}`),
                loadFaceFailList(clubid, startTime, endTime)
            ]);

            setWeekGraphData({
                loginLog: loginRes.data.result === 1 ? loginRes.data.infos : null,
                faceFailLog
            });
        } catch (error) {
            console.error('주간 그래프 데이터 로드 실패:', error);
        }
    };

    const setChangeStatusInfo = async ()=>{
        const queryString = qs.stringify({
            socketKey,
        });
        let res = await client.patch(`${url}/api/clubs/club/statusupdate/${selectClub}?${queryString}`, {clubStatus:selectClubInfo.clubStatus});
        console.log('setChangeStatusInfo : ', res.data)
        if(res && res.data && res.data.result == 1) {
            alert('활성화 정보가 수정되었습니다.')

            let _selectClubInfo = { ...selectClubInfo }
            _selectClubInfo.isStatusEdit = false;
            setSelectClubInfo(_selectClubInfo)

            dispatch(
                loadAllClubList({
                    playerID: Number(user.playerID),
                    socketKey,
                }),
            );
        }
        else {
            alert('활성화 정보 수정에 실패하였습니다.')
        }
    }

    const addDeviceInfo = async (deviceInfo)=>{
        let res = await client.post(`${url}/api/runningtrack/deviceinfo/${selectClub}`, deviceInfo)
        _resetClubInfo(selectClub)
    }

    const deleteDeviceInfo = async (deviceInfo)=>{
        let res = await client.delete(`${url}/api/runningtrack/deviceinfo/${selectClub}/${deviceInfo.number}/${deviceInfo.devicetype}`)
        _resetClubInfo(selectClub)
    }

    // 데이터 새로고침 함수
    const refreshData = () => {
        _resetClubInfo(selectClub);
    }

    const resetDashboardData = () => {
        loadDashboardData(selectClub, dashRange);
    }

    return (
        <>
            <TabBlock>
                <TabText active={subTab === 'club'} onClick={() => setSubTab('club')}>클럽</TabText>
                <TabText active={subTab === 'music'} onClick={() => setSubTab('music')}>유튜브 뮤직</TabText>
                <TabText active={subTab === 'launcher'} onClick={() => setSubTab('launcher')}>제타트랙 런처</TabText>
            </TabBlock>
            {subTab === 'club' && <>
                <ClubSelectItem
                    clubList={clubList}
                    selectClub={selectClub}
                    setSelectClub={setSelectClub}
                />
                {Number(selectClub) > 0 && <ZetaViewTabs tabs={VIEW_TABS} value={viewTab} onChange={setViewTab} />}
                {viewTab === 'dash' && <AdminClubRunningTrackInfo
                    selectClub={selectClub}
                    deviceInfos={deviceInfos}
                    addDeviceInfo={addDeviceInfo}
                    deleteDeviceInfo={deleteDeviceInfo}
                    onRefreshData={refreshData}
                    dashboardData={dashboardData}
                    weekGraphData={weekGraphData}
                    onLoadWeekData={loadWeekGraphData}
                    onLoadFaceFailList={loadFaceFailList}
                    onResetDashboardData={resetDashboardData}
                    dashRange={dashRange}
                    onDashRangeChange={setDashRange}
                    socketKey={socketKey}
                />}
                {Number(selectClub) > 0 && viewTab === 'rank' && <ZetaRanking key={selectClub} clubID={selectClub} socketKey={socketKey} />}
                {Number(selectClub) > 0 && viewTab === 'stats' && <ZetaDailyStats key={selectClub} clubID={selectClub} socketKey={socketKey} />}
                {Number(selectClub) > 0 && viewTab === 'members' && <ZetaMembers key={selectClub} clubID={selectClub} socketKey={socketKey} />}
                {Number(selectClub) > 0 && viewTab === 'mr' && <ZetaMultiRun key={selectClub} clubID={selectClub} socketKey={socketKey} />}
            </>}
            {subTab === 'music' && (
                <AdminClubYoutubeMusic />
            )}
            {subTab === 'launcher' && (
                <AdminLauncherAppDownload />
            )}
        </>
    );
};

export default AdminClubRunningTrackInfoContainer;
